export default __webpack_public_path__ + "static/media/icon-Dale02.31a6511f.svg";